import React, { Component } from 'react';
import Picture from '../Shared/Picture';

class SplitArticle extends Component {
    render() {
        return (
            <div className="article-columns">
                <div className="article-column article-column--left">
                    <div dangerouslySetInnerHTML={{"__html": this.props.article.Description.Value }}></div>
                    <div className="teaser-media shadow shadow-blue">
                        <a href={this.props.article.ImageLink.Value} >
                            <Picture src={this.props.article.Image.Value} alt={this.props.article.ImageAlt.Value} />
                        </a>
                    </div>
                </div>
                <div className="article-column article-column--right">
                    <div className="teaser-media shadow shadow-blue">
                        <a href={this.props.article.SplitImageLink.Value} >
                            <Picture src={this.props.article.SplitImage.Value} alt={this.props.article.SplitImageAlt.Value} />
                        </a>
                    </div>
                    <div dangerouslySetInnerHTML={{"__html": this.props.article.SplitDescription.Value }}></div>
                </div>
                {
                   this.props.article.SplitImage1 && this.props.article.SplitImage1.Value.length > 0 ? (
                    <div className="article-column article-column--additional">
                        <div className="teaser-media shadow shadow-blue">
                            <a href={this.props.article.SplitImage1Link.Value} >
                                <Picture src={this.props.article.SplitImage1.Value} alt={this.props.article.SplitImage1Alt.Value} />
                            </a>
                        </div>
                        <div dangerouslySetInnerHTML={{"__html": this.props.article.SplitDescription1.Value }}></div>
                    </div>
                   ) :
                   null
                }
            </div>
        )
    }
}

export default SplitArticle;
